import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledButton, StyledLink } from "../../../Styled/Button"
import { StyledRule } from "../../../Styled/Rule"

export const List = styled.div`
  ${tw`mt-6 bg-white border border-grey-light rounded cursor-pointer transition-colors duration-200`}
  ${({ locked, premium }) => (locked || premium) && tw`border-none`}
  ${({ active, locked, premium }) => active && (locked || premium) && tw`shadow-lg`}
  ${({ active, locked, premium }) => !active && !locked && !premium && tw`hover:border-teal-dark`}
`
export const Toggle = styled(StyledLink)`
  ${tw`py-3.25 px-5 flex items-center justify-between w-full text-left`}
  ${({ locked }) => locked && tw`py-2.25 bg-grey-lighter text-grey hover:bg-orange hover:text-white`}
  ${({ premium }) => premium && tw`py-2.25 mb-6 bg-orange text-white hover:text-white hover:bg-orange-dark`}
  ${({ active }) => (active ? tw`rounded-t` : tw`rounded`)}
`
export const Button = tw(StyledButton)`w-full mt-6.5`
export const Upsell = tw.div`my-8 text-center`
export const UpsellButton = tw(StyledButton)`w-full mt-3`
export const Rule = tw(StyledRule)`mt-0 mb-6`
export const Items = styled.div`
  ${tw`pb-7.5 px-5`}
  ${({ hidden }) => hidden && tw`hidden`}
`
export const IconCircle = styled.div`
  ${tw`flex flex-shrink-0 items-center justify-center bg-white text-orange group-hover:text-orange-dark rounded-full w-7.5 h-7.5 mr-3 transition-colors duration-200`}
  ${({ locked }) => locked && tw`bg-grey text-grey-lighter group-hover:bg-white group-hover:text-orange`}
`
export const IconWrapper = styled.div`
  ${tw`ml-3 transition-transform duration-200 transform`}
  ${({ active }) => active && tw`rotate-180`}
`
